import type { IntlShape } from 'react-intl';

/**
 * Generates screen reader accessible text for star ratings
 * @param intl - The react-intl IntlShape object
 * @param rating - The rating number
 * @returns Translated screen reader text describing the rating
 */
const totalStars = 5;
const getScreenReaderRatingText = (intl: IntlShape, rating: number): string => {
  const localizedRating = intl.formatNumber(rating, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return intl.formatMessage({ defaultMessage: '{rating} stars out of {totalStars}' }, { rating: localizedRating, totalStars });
};

export default getScreenReaderRatingText;
